import { Component, h, Host, Element, State } from '@stencil/core';

@Component({
  tag: 'spw-header-persona',
  styleUrl: 'spw-header-persona.scss',
  shadow: true,
})
export class SpwHeaderPersona {
  @Element() el!: HTMLElement;
  @State() activePersona: string = '';
  @State() isOpen: boolean = false;

  componentWillLoad() {
    this.updateActivePersona();
  }

  private updateActivePersona() {
    const items = this.el.querySelectorAll('spw-header-persona-item');
    items.forEach((item: HTMLElement) => {
      if (item.getAttribute('active') === 'true') {
        this.activePersona = item.getAttribute('persona') || '';
      }
    });
  }

  handleSelect(persona: string) {
    this.activePersona = persona;
    const items = this.el.querySelectorAll('spw-header-persona-item');
    items.forEach((item: HTMLElement) => {
      item.setAttribute('active', item.getAttribute('persona') === persona ? 'true' : 'false');
    });
  }

  private toggleDropdown(): void {
    this.isOpen = !this.isOpen;
  }

  render() {
    return (
      <Host>
        <div class={{ 'spw-header-persona': true, 'spw-header-persona--opened': this.isOpen }}>
          <div class="spw-header-persona__active-persona" onClick={() => this.toggleDropdown()}>
            {this.activePersona}
            <span class="spw-header-persona__trigger">
              <spw-icon icon="fa-chevron-down"></spw-icon>
            </span>
          </div>
          <div class="spw-header-persona__dropdown">
            <slot />
          </div>
        </div>
      </Host>
    );
  }
}
